export default {
    namespaced: true,
    state: {
        authenticated: false,
        permissions: []
    },
    mutations: {
    }
};